<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} Page</div>
      <router-link class="btn-blue" :to="{name:'Pages'}">{{$t("Pages")}} {{ $tc("list") }}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Page Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="selectedPage" class="mr-3">{{selectedPage.page_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Meta Title:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.seo_meta_title}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Meta Description:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.seo_meta_description}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Meta Keywords:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.seo_meta_keywords}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">OG Type:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.og_type}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">OG Site:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.og_site}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">SEO is active:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{seo_obj.seo_meta_is_active == 'Y' ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import Vue from 'vue';
import VueDragDrop from 'vue-drag-drop';
 
Vue.use(VueDragDrop);

export default {
  data() {
    return {
        websitePages:[],
        selectedPage: null,
        seo_obj:{
            seo_meta_id: null,
            seo_meta_title: '',
            seo_meta_description:'',
            seo_meta_keywords: '',
            seo_meta_is_active:'Y',
            og_type:'',
            og_site:''
        },
      submitted: false,
      keys:['@movie', '@cinema', '@language', '@genre'],
      
      category_is_active: true
    };
  },
  mounted(){
      const {seo_id} = this.$route.params;
      if(seo_id){
         this.getSeoData(seo_id) 
      }else{
          this.$router.go(-1)
      }
    //   this.getWebsitePages()
  },
  methods: {
    // onResetForm: function() {
    //    this.selectedPage = null
    //         this.seo_obj.seo_meta_title = '',
    //         this.seo_obj.seo_meta_description = '',
    //         this.seo_obj.seo_meta_keywords = '',
    //         this.seo_obj.seo_meta_is_active = 'Y',
    //         this.seo_obj.og_type = '',
    //         this.seo_obj.og_site = ''
    //         console.log('this.seo_obj.seo_meta_id :>> ', this.seo_obj.seo_meta_id);
    //  },
       getSeoData: function(seo_id) {
        MarketingService.GetPage({seo_id:seo_id})
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.seo_obj = { 
            seo_meta_id: data.Records[0].seo_meta_id,    
            seo_meta_title: data.Records[0].seo_meta_title,
            seo_meta_description: data.Records[0].seo_meta_description,
            seo_meta_keywords: data.Records[0].seo_meta_keywords,
            seo_meta_is_active: data.Records[0].seo_meta_is_active,
            og_type: data.Records[0].og_type,
            og_site: data.Records[0].og_site};
              console.log('this.seo_obj :>> ', this.seo_obj);
              this.getWebsitePages(data.Records[0].seo_id)
            } else {
            //   this.seo_list = []
              this.$toasted.show(data.message)
            }
          })
          .catch(error => {
            this.$toasted.show(error)
          });
      
    },
    // setKeywords(event){
    //   console.log('event :>> ', event);
    //   this.seo_obj.seo_meta_keywords += ` ${event}`
    // },
    //  setDescription(event){
    //   console.log('event :>> ', event);
    //   this.seo_obj.seo_meta_description += ` ${event}`
    // },
    //  setTitle(event){
    //   console.log('event :>> ', event);
    //   this.seo_obj.seo_meta_title += ` ${event}`
    // },
      getWebsitePages: function(seo_id) {
        let payload = {
          tableName: "ms_pages",
          page_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.websitePages = data.Records;
              this.websitePages.map(x =>{
              if(x.seo_id == seo_id)    
              this.selectedPage = x
              })
              
            } else {
              this.$toasted.show(data.message)
            }
          })
          .catch(error => {
            this.$toasted.show(error)
          });
      
    },
    // editSeo() {
    //   this.submitted = true;
    //   if(this.selectedPage){
    //   this.$validator.validate().then(valid => {
    //     if (valid) {
    //       // let loader = this.$loading.show();

    //       // console.log("JSON.stringify :", JSON.stringify(finalObj));
    //       let payload = {
    //         page_id : this.selectedPage.seo_id,
    //         seo_obj : this.seo_obj
    //       };
    //       MarketingService.EditSeo(payload)
    //         .then(response => {
    //           const { data } = response;
    //           // loader.hide();
    //           if (data && data.status) {
    //             this.$toasted.show(data.message);

    //             this.$router.push({
    //               path: "/marketing/list-seo"
    //             });
    //           } else {
    //             this.$toasted.show(data.message);
    //           }
    //         })
    //         .catch(this._CatchError);
    //     } else {
    //       this.$toasted.show("Please enter all details");
    //     }
    //   });
    // }else{
    //   this.$toasted.show('Please select a page')
    // }
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PageComponents/viewPage.vue